<template>
	<details
		ref="details"
		class="eia-accordion"
		@toggle="toggle">
		<summary>
			<eia-icon name="chevron-right"></eia-icon>
			<span class="eia-accordion__title"><slot name="title"></slot></span>
		</summary>

		<div class="eia-accordion__content">
			<slot></slot>
		</div>
	</details>
</template>

<script>
export default {
	name: 'eia-accordion',
	props: {
		open: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		open( val ){
			if( val !== this.$refs.details.open ){
				this.$refs.details.open = val;
			}
		},
	},
	methods: {
		toggle( e ){
			this.$emit( 'toggle', e.srcElement.open );
		},
	},
};
</script>

<style lang="scss">
.eia-accordion {
	color: $color-main;
	margin: 16px 0;
	font-size: $text-subheading;

	summary {
		list-style: none;
		cursor: pointer;
		user-select: none;
		margin-bottom: 8px;

		&,
		.eia-icon {
			color: $color-primary;
		}

		.eia-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			transition: transform 150ms ease;
			transform: rotate( 0deg );
			font-size: 0.7em;
			width: 16px;
			height: 16px;
			margin-right: 8px;
		}

		&::-webkit-details-marker {
			display: none;
		}
	}

	&__title {
		text-decoration: underline;
	}

	&__content {
		margin-left: 24px;

		> .eia-indented {
			margin-left: -33px !important;
		}
	}

	&[open] {
		.eia-icon {
			transform: rotate( 90deg );
		}
	}
}
</style>
